// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    border-radius: 0px !important;
}

tr:nth-child(even) {
    background-color: whitesmoke;
  }
  tr:nth-child(odd) {
    background-color: rgb(250, 250, 250);
  }
  #qusDiv:nth-child(even) {
    background-color: whitesmoke;
  }
  #qusDiv:nth-child(odd) {
    background-color: white;
  }
.tblPermitTemplate {
    width: 98%;
}
/* .parentDiv
{
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
}
.watermark {
    
    margin: 35%;
    margin-left: 25%;
   width: 150px;
   height: 150px;
    font-weight: bold;
    font-size: 400%;
  
    color: #504e4e;
    opacity: 0.2; 
    transform: rotate(-25deg) scale(1.7, 1.5);
  } */

  .watermark {
   
    margin-top: auto;
    margin-bottom: auto;
    margin-right: auto;
    margin-left: 30%;
    position: absolute;
    z-index: 999;
    top:0;
    bottom: 0;
    text-align: center;
      /* margin: auto; */
     left: 0;
     right: 0;
     width: 150px;
     height: 150px;
     font-weight: bold;
     font-size: 400%;
     color: #504e4e;
     opacity: 0.2; 
      transform: rotate(-6deg) scale(1.7, 1.5); 
   }

.clsLogo {
    height: 51px;
    width: 180px;
    /* border: 1px solid #1F4E78; */
    padding-right: 5px;
    margin-top: 7px;
}

.mapImage{
    height: 800px !important;
    width:100% !important;
}

.clsLogoHidden {
    height: 45px;
    width: 157px;
    padding-right: 5px;
    padding-top: 10px;
    padding-bottom: -5px;
}

:host ::ng-deep .ui-inputtext {
    /* width: 250px !important; */
    margin: 0;
    outline: medium none;
    padding: .25em;
    font-weight: normal;
}

:host ::ng-deep input[type=text] {
    border-radius: 0px !important;
}

.clsHeader {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    margin-left: -20px;
}

.clsHeaderWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
    /* margin-left: -6px; */
}
:host ::ng-deep input[disabled] {
    color: #848484!important;
     background-color: white!important; 
}
disabled{
   
        color: #848484!important;
       background-color: white!important;
    
}

.clsHeaderHiddenChild {
    background-color: White;
    width: 30px;
    height: 100%;
    position: absolute;
    left: 10px;
}

/* .clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    margin-left: -20px;
} */


/* .clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 40px;
    padding: 10px;
    font-weight: bold;
   
} */
.clsHeaderHidden {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    /* padding: 10px; */
    font-weight: bold;
    width: 100%;
    text-align: center;
}
.clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 50px;
    /* padding: 10px; */
    font-weight: bold;
    width: 100%;
    text-align: center;
    /* margin-left: -6px; */
}
.left {

    display: table-cell;
    /* width:6%; */

}
.middle {

    display: table-cell;
    width:100%;
}
.right {

    display: table-cell;
    width:10%;

}



/* .clsHeaderHiddenWithoutImage {
    color: White;
    background-color: #1F4E78;
    font-size: 30px;
    padding: 10px;
    font-weight: bold;
    width: 83%;
    /* margin-left: -6px; 
} */

/* .tblPermitTemplate td {
 
    background-color: white;
} */

/* .tblPermitTemplate tr {
    border: 1px solid #1F4E78;
} */

.tblPermitTemplate tr th {
    /* background-color: #1F4E78; */
    color: white;
}

.tblPermitTemplate tr td, .tblPermitTemplate tr th {
    padding: 6px;
}

.clsValue {
    color: black;
    /* font-weight: bold; */
    margin-left: 5px;
}

.clsTextArea {
    color: black;
    border: 1px solid #1F4E78;
    resize: none;
}

.clsTable {
    margin: 5px 5px 0px 0px;
    width: 100%;
}

.clsTable td {
    /* border: 3px solid white !important; */
    border: 1px solid lightgray !important;
}

.clsTable th {
    border: 1px solid black;
}
:host ::ng-deep .ui-chkbox .ui-chkbox-box {
    border: 1px solid #000000 !important;
}
:host ::ng-deep .ui-radiobutton .ui-radiobutton-box{
    border: 1px solid #000000 !important;
}
.clsTablesContainer {
    overflow: auto;
    /* height: 425px; */
    margin-bottom: 5px;
}

.clsBgWhite {
    background-color: white;
    /* margin-bottom: 10px; */
}

.clsHeaderParent {
    width: 98.5%;
    padding-left: 30px;
    background-color: White;
}

#pnlPreviewTemp {
    background-color: white;
    position: relative;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 30px !important;
}

/* .clsMarginBottom {
    margin-top: 15px !important;
    line-height: 30px;
    border-collapse: separate;
    border-spacing: 0 2em; 
}*/

.clsCheckboxContainer {
    padding: 5px;
    color: black;
    font-size: 30px;
}

.clsCheckBox {
    height: 80px;
    overflow: auto;
}

.clsCheckboxDownContainer {
    padding: 5px;
    color: black;
    font-size: 30px;
    word-break: break-all;
}

.btn-primary {
    margin-right: 5px !important;
}

:host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788 !important;
    border-radius: 3px;
    background: #f4f4f4 !important;
    box-shadow: 3px 3px 12px #165788;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #ffffff !important;
    /* margin-top: 10px; */
}

.toast-header {
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;
}

.approveMessage {
    color: #ff3232;
    font-weight: normal;
}

/* .permitTypeImages {
    height: 68px;
    width: 88%;
} */

.permitTypeImages {
    /* max-height: 88px;
    height: 100%;
     width: 100%;
     min-width: 88px; */
     width: 70px;
    height: 71px;
 }

.disabled {
    cursor: not-allowed;
    pointer-events: none;
}

:host ::ng-deep .p-dialog-mask {
    z-index: auto !important;
    position: relative;
}
:host ::ng-deep .ui-chkbox-label{
    font-size: 30px !important;
}

:host ::ng-deep .ui-radiobutton-label{
    font-size: 30px !important;
}
.clsShift {
    left: -3px !important;
}

.vrtAlignLbl {
    padding: 7px 0px 0px 0px;
    font: 13px !important;
}
.indentTable {
    position: relative;
    left: 6px !important;
    padding-right: 10px;
}

.row-align {
    padding: 5px 5px 5px 5px !important;
}

/* :host ::ng-deep body .ui-chkbox .ui-chkbox-box .ui-chkbox-icon {
    font-size: 20px !important;
  } */
  :host ::ng-deep body .ui-radiobutton-label {
    font-size: 30px !important;
  }
  :host ::ng-deep  body .ui-chkbox-label {
    font-size: 30px !important;
  }
  span{
    color: #000000 !important;
}

.clsTablesContainer td{
    border-color: Gray !important;
}

input[type=url], input[type=search], input[type=text], input[type=datetime], input[type=date], textarea {
    font-size: 30px !important;
}

.text-style {
    font-style: italic !important;
}

.clsInnerHtml,
.clsInnerHtml *,
.clsInnerHtml p,
.clsInnerHtml span {
    display: block !important;
    white-space: normal !important;
    overflow-wrap: break-word !important;
    word-break: normal !important;
    max-width: 100%;
    width: 96% !important;
}

/* Text element width class for textbox, textarea, label, paragraph content */
.clsTextElementWidth {
    width: 98% !important;
    padding-left: 15px;
}

.blank-height {
    min-height: 35px !important; 
    display: inline-block !important;
}

/* .clsBorder{
    border: 1px solid lightgrey !important;
} */

/* :host ::ng-deep .clsInnerHtml > p > span{
    margin-left: 8px !important;
    float: left !important;
} */

.left-margin {
    /* padding: 5px 10px !important; */
    padding: 0px 0px 0px 10px !important;
}

.left-margin {
    padding: 0px 0px 0px 6px !important;
}

.padding-left-15 {
    padding-left: 11px;
}

.paragraph-margin {
    padding: 0px 0px 7px 0px!important;
}

.upload-margin {
    padding-top: 10px !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/print-pdf-selected/print-pdf-selected.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;EAC9B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;AACF;IACI,UAAU;AACd;AACA;;;;;;;;;;;;;;;;;;;;KAoBK;;EAEH;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,KAAK;IACL,SAAS;IACT,kBAAkB;MAChB,kBAAkB;KACnB,OAAO;KACP,QAAQ;KACR,YAAY;KACZ,aAAa;KACb,iBAAiB;KACjB,eAAe;KACf,cAAc;KACd,YAAY;MACX,wCAAwC;GAC3C;;AAEH;IACI,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,uBAAuB;AAC3B;AACA;IACI,wBAAwB;KACvB,iCAAiC;AACtC;AACA;;QAEQ,wBAAwB;OACzB,iCAAiC;;AAExC;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;;;;;GAOG;;;AAGH;;;;;;;GAOG;AACH;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;;IAEI,mBAAmB;IACnB,cAAc;;AAElB;AACA;;IAEI,mBAAmB;IACnB,UAAU;AACd;AACA;;IAEI,mBAAmB;IACnB,SAAS;;AAEb;;;;AAIA;;;;;;;;GAQG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;;;;;EAKE;;AAEF;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;IAG9B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI;;;uBAGmB;KAClB,WAAW;IACZ,YAAY;CACf;;AAED;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;KAEK;EACH;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;IAII,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;IACpC,6BAA6B;IAC7B,eAAe;IACf,qBAAqB;AACzB;;AAEA,6EAA6E;AAC7E;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["* {\r\n    border-radius: 0px !important;\r\n}\r\n\r\ntr:nth-child(even) {\r\n    background-color: whitesmoke;\r\n  }\r\n  tr:nth-child(odd) {\r\n    background-color: rgb(250, 250, 250);\r\n  }\r\n  #qusDiv:nth-child(even) {\r\n    background-color: whitesmoke;\r\n  }\r\n  #qusDiv:nth-child(odd) {\r\n    background-color: white;\r\n  }\r\n.tblPermitTemplate {\r\n    width: 98%;\r\n}\r\n/* .parentDiv\r\n{\r\n    position: absolute;\r\n    top:0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n}\r\n.watermark {\r\n    \r\n    margin: 35%;\r\n    margin-left: 25%;\r\n   width: 150px;\r\n   height: 150px;\r\n    font-weight: bold;\r\n    font-size: 400%;\r\n  \r\n    color: #504e4e;\r\n    opacity: 0.2; \r\n    transform: rotate(-25deg) scale(1.7, 1.5);\r\n  } */\r\n\r\n  .watermark {\r\n   \r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    margin-right: auto;\r\n    margin-left: 30%;\r\n    position: absolute;\r\n    z-index: 999;\r\n    top:0;\r\n    bottom: 0;\r\n    text-align: center;\r\n      /* margin: auto; */\r\n     left: 0;\r\n     right: 0;\r\n     width: 150px;\r\n     height: 150px;\r\n     font-weight: bold;\r\n     font-size: 400%;\r\n     color: #504e4e;\r\n     opacity: 0.2; \r\n      transform: rotate(-6deg) scale(1.7, 1.5); \r\n   }\r\n\r\n.clsLogo {\r\n    height: 51px;\r\n    width: 180px;\r\n    /* border: 1px solid #1F4E78; */\r\n    padding-right: 5px;\r\n    margin-top: 7px;\r\n}\r\n\r\n.mapImage{\r\n    height: 800px !important;\r\n    width:100% !important;\r\n}\r\n\r\n.clsLogoHidden {\r\n    height: 45px;\r\n    width: 157px;\r\n    padding-right: 5px;\r\n    padding-top: 10px;\r\n    padding-bottom: -5px;\r\n}\r\n\r\n:host ::ng-deep .ui-inputtext {\r\n    /* width: 250px !important; */\r\n    margin: 0;\r\n    outline: medium none;\r\n    padding: .25em;\r\n    font-weight: normal;\r\n}\r\n\r\n:host ::ng-deep input[type=text] {\r\n    border-radius: 0px !important;\r\n}\r\n\r\n.clsHeader {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    margin-left: -20px;\r\n}\r\n\r\n.clsHeaderWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n    /* margin-left: -6px; */\r\n}\r\n:host ::ng-deep input[disabled] {\r\n    color: #848484!important;\r\n     background-color: white!important; \r\n}\r\ndisabled{\r\n   \r\n        color: #848484!important;\r\n       background-color: white!important;\r\n    \r\n}\r\n\r\n.clsHeaderHiddenChild {\r\n    background-color: White;\r\n    width: 30px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 10px;\r\n}\r\n\r\n/* .clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    margin-left: -20px;\r\n} */\r\n\r\n\r\n/* .clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 40px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n   \r\n} */\r\n.clsHeaderHidden {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    /* padding: 10px; */\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n.clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 50px;\r\n    /* padding: 10px; */\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: center;\r\n    /* margin-left: -6px; */\r\n}\r\n.left {\r\n\r\n    display: table-cell;\r\n    /* width:6%; */\r\n\r\n}\r\n.middle {\r\n\r\n    display: table-cell;\r\n    width:100%;\r\n}\r\n.right {\r\n\r\n    display: table-cell;\r\n    width:10%;\r\n\r\n}\r\n\r\n\r\n\r\n/* .clsHeaderHiddenWithoutImage {\r\n    color: White;\r\n    background-color: #1F4E78;\r\n    font-size: 30px;\r\n    padding: 10px;\r\n    font-weight: bold;\r\n    width: 83%;\r\n    /* margin-left: -6px; \r\n} */\r\n\r\n/* .tblPermitTemplate td {\r\n \r\n    background-color: white;\r\n} */\r\n\r\n/* .tblPermitTemplate tr {\r\n    border: 1px solid #1F4E78;\r\n} */\r\n\r\n.tblPermitTemplate tr th {\r\n    /* background-color: #1F4E78; */\r\n    color: white;\r\n}\r\n\r\n.tblPermitTemplate tr td, .tblPermitTemplate tr th {\r\n    padding: 6px;\r\n}\r\n\r\n.clsValue {\r\n    color: black;\r\n    /* font-weight: bold; */\r\n    margin-left: 5px;\r\n}\r\n\r\n.clsTextArea {\r\n    color: black;\r\n    border: 1px solid #1F4E78;\r\n    resize: none;\r\n}\r\n\r\n.clsTable {\r\n    margin: 5px 5px 0px 0px;\r\n    width: 100%;\r\n}\r\n\r\n.clsTable td {\r\n    /* border: 3px solid white !important; */\r\n    border: 1px solid lightgray !important;\r\n}\r\n\r\n.clsTable th {\r\n    border: 1px solid black;\r\n}\r\n:host ::ng-deep .ui-chkbox .ui-chkbox-box {\r\n    border: 1px solid #000000 !important;\r\n}\r\n:host ::ng-deep .ui-radiobutton .ui-radiobutton-box{\r\n    border: 1px solid #000000 !important;\r\n}\r\n.clsTablesContainer {\r\n    overflow: auto;\r\n    /* height: 425px; */\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.clsBgWhite {\r\n    background-color: white;\r\n    /* margin-bottom: 10px; */\r\n}\r\n\r\n.clsHeaderParent {\r\n    width: 98.5%;\r\n    padding-left: 30px;\r\n    background-color: White;\r\n}\r\n\r\n#pnlPreviewTemp {\r\n    background-color: white;\r\n    position: relative;\r\n    padding-left: 30px;\r\n    padding-right: 30px;\r\n    font-size: 30px !important;\r\n}\r\n\r\n/* .clsMarginBottom {\r\n    margin-top: 15px !important;\r\n    line-height: 30px;\r\n    border-collapse: separate;\r\n    border-spacing: 0 2em; \r\n}*/\r\n\r\n.clsCheckboxContainer {\r\n    padding: 5px;\r\n    color: black;\r\n    font-size: 30px;\r\n}\r\n\r\n.clsCheckBox {\r\n    height: 80px;\r\n    overflow: auto;\r\n}\r\n\r\n.clsCheckboxDownContainer {\r\n    padding: 5px;\r\n    color: black;\r\n    font-size: 30px;\r\n    word-break: break-all;\r\n}\r\n\r\n.btn-primary {\r\n    margin-right: 5px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788 !important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4 !important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #ffffff !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header {\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;\r\n}\r\n\r\n.approveMessage {\r\n    color: #ff3232;\r\n    font-weight: normal;\r\n}\r\n\r\n/* .permitTypeImages {\r\n    height: 68px;\r\n    width: 88%;\r\n} */\r\n\r\n.permitTypeImages {\r\n    /* max-height: 88px;\r\n    height: 100%;\r\n     width: 100%;\r\n     min-width: 88px; */\r\n     width: 70px;\r\n    height: 71px;\r\n }\r\n\r\n.disabled {\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\n:host ::ng-deep .p-dialog-mask {\r\n    z-index: auto !important;\r\n    position: relative;\r\n}\r\n:host ::ng-deep .ui-chkbox-label{\r\n    font-size: 30px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-radiobutton-label{\r\n    font-size: 30px !important;\r\n}\r\n.clsShift {\r\n    left: -3px !important;\r\n}\r\n\r\n.vrtAlignLbl {\r\n    padding: 7px 0px 0px 0px;\r\n    font: 13px !important;\r\n}\r\n.indentTable {\r\n    position: relative;\r\n    left: 6px !important;\r\n    padding-right: 10px;\r\n}\r\n\r\n.row-align {\r\n    padding: 5px 5px 5px 5px !important;\r\n}\r\n\r\n/* :host ::ng-deep body .ui-chkbox .ui-chkbox-box .ui-chkbox-icon {\r\n    font-size: 20px !important;\r\n  } */\r\n  :host ::ng-deep body .ui-radiobutton-label {\r\n    font-size: 30px !important;\r\n  }\r\n  :host ::ng-deep  body .ui-chkbox-label {\r\n    font-size: 30px !important;\r\n  }\r\n  span{\r\n    color: #000000 !important;\r\n}\r\n\r\n.clsTablesContainer td{\r\n    border-color: Gray !important;\r\n}\r\n\r\ninput[type=url], input[type=search], input[type=text], input[type=datetime], input[type=date], textarea {\r\n    font-size: 30px !important;\r\n}\r\n\r\n.text-style {\r\n    font-style: italic !important;\r\n}\r\n\r\n.clsInnerHtml,\r\n.clsInnerHtml *,\r\n.clsInnerHtml p,\r\n.clsInnerHtml span {\r\n    display: block !important;\r\n    white-space: normal !important;\r\n    overflow-wrap: break-word !important;\r\n    word-break: normal !important;\r\n    max-width: 100%;\r\n    width: 96% !important;\r\n}\r\n\r\n/* Text element width class for textbox, textarea, label, paragraph content */\r\n.clsTextElementWidth {\r\n    width: 98% !important;\r\n    padding-left: 15px;\r\n}\r\n\r\n.blank-height {\r\n    min-height: 35px !important; \r\n    display: inline-block !important;\r\n}\r\n\r\n/* .clsBorder{\r\n    border: 1px solid lightgrey !important;\r\n} */\r\n\r\n/* :host ::ng-deep .clsInnerHtml > p > span{\r\n    margin-left: 8px !important;\r\n    float: left !important;\r\n} */\r\n\r\n.left-margin {\r\n    /* padding: 5px 10px !important; */\r\n    padding: 0px 0px 0px 10px !important;\r\n}\r\n\r\n.left-margin {\r\n    padding: 0px 0px 0px 6px !important;\r\n}\r\n\r\n.padding-left-15 {\r\n    padding-left: 11px;\r\n}\r\n\r\n.paragraph-margin {\r\n    padding: 0px 0px 7px 0px!important;\r\n}\r\n\r\n.upload-margin {\r\n    padding-top: 10px !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
